import { Navigate } from "react-router-dom";
import { LoadingSpinner } from "@/core/components/loading-spinner";
import { Stack } from "@/core/components/ui/stack";
import { useBusiness } from "@/core/business";
import { FEATURE_FLAG_NAMES } from "@/core/feature-flags/feature-flag-name";
import { useFeatureFlag } from "@/core/feature-flags/use-feature-flag";
import { useGetPocketflowsEmbedUrl } from "./query";

export const Campaigns = () => {
  const {
    businessId,
    isLoading: isBusinessLoading,
    selectedBusiness: { is_pocketflows_enabled } = {},
  } = useBusiness();

  const {
    enabled: enablePocketflowsFlag,
    isLoading: isEnablePocketflowsLoading,
  } = useFeatureFlag(FEATURE_FLAG_NAMES.enable_pocketflows);

  const { data, isLoading } = useGetPocketflowsEmbedUrl(businessId);
  const embedUrl = data?.url;

  if (isLoading || isBusinessLoading || isEnablePocketflowsLoading) {
    return (
      <Stack
        align="center"
        justify="center"
        className="h-[calc(100vh-64px)] w-full"
      >
        <LoadingSpinner />
      </Stack>
    );
  }

  if (!is_pocketflows_enabled || !enablePocketflowsFlag || !embedUrl) {
    return <Navigate to="/" />;
  }

  return (
    <Stack
      align="center"
      justify="center"
      className="h-[calc(100vh-64px)] w-full"
    >
      <iframe src={embedUrl} className="h-full w-full" />
    </Stack>
  );
};
